module.exports = __webpack_public_path__ + "img/lineicon.2d8b0641.svg";